'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _analyticsManager = require('../utils/analytics/analyticsManager');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var publishAnalytics = function publishAnalytics(data, dataKey, props) {
    var virtualPath = '/vp/publish';
    if (!props.isEdit) {
        switch (dataKey) {
            case 'fields':{
                    var sections = {
                        ad: ['section', 'search_option', 'property_type'],
                        address: ['address.isFull'],
                        propertyDetails: ['rooms', 'area.base',
                        'floor.on_the', 'floor.out_of', 'groundFloor', 'hasBasement',
                        'parking.aboveground', 'parking.underground', 'balconies',
                        'light_direction.east', 'light_direction.north',
                        'light_direction.south', 'light_direction.west',
                        'bathrooms', 'toilets', 'payments.tax'],

                        buildingDetails: ['construction_year',
                        'elevators', 'payments.maintenance'],

                        commodities: ['commodities'],
                        imagesVideos: ['images', 'videos'],
                        priceDetails: ['price', 'entry_date.date'] };

                    for (var sectionKey in sections) {
                        if ({}.hasOwnProperty.call(sections, sectionKey)) {
                            for (var _iterator = sections[sectionKey], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref;if (_isArray) {if (_i >= _iterator.length) break;_ref = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref = _i.value;}var elementKey = _ref;
                                var elementValue = (0, _get2.default)(data, elementKey);
                                if (elementValue !== undefined && elementValue !== null &&
                                elementValue !== (0, _get2.default)(props.fields, elementKey)) {
                                    switch (sectionKey) {
                                        case 'ad':
                                        case 'address':
                                        case 'propertyDetails':{
                                                (0, _analyticsManager.trackPage)(virtualPath + '/' + sectionKey + '/' + elementKey + '/' + elementValue);
                                                return;
                                            }
                                        case 'commodities':{
                                                (0, _analyticsManager.trackPage)(virtualPath + '/' + sectionKey + '/' + elementValue);
                                                return;
                                            }
                                        case 'imagesVideos':{
                                                if (elementValue.length > 0) {
                                                    (0, _analyticsManager.trackPage)(virtualPath + '/' + sectionKey + '/\n                                            ' +
                                                    elementKey + '/' + elementValue.length);
                                                }
                                                return;
                                            }
                                        default:{
                                                (0, _analyticsManager.trackPage)(virtualPath + '/' + sectionKey + '/' + elementKey);
                                                return;
                                            }}

                                }
                            }
                        }
                    }
                    break;
                }
            case 'userAuthentication':{
                    var _elementValue = (0, _get2.default)(data, 'userIsAuthorized');
                    if (_elementValue !== undefined && _elementValue !== null &&
                    _elementValue !== (0, _get2.default)(props.userAuthentication, 'userIsAuthorized')) {
                        (0, _analyticsManager.trackPage)(virtualPath + '/' + dataKey + '/' + _elementValue);
                    }
                    break;
                }
            case 'package':{
                    var route = virtualPath + '/' + dataKey;
                    if (data.checked !== undefined && data.checked !== null) {
                        route += '/type/' + data.checked;
                    }
                    if (data.period !== undefined && data.period !== null) {
                        route += '/period/' + data.period;
                    }
                    (0, _analyticsManager.trackPage)(route);
                    break;
                }
            default:{
                    (0, _analyticsManager.trackPage)(virtualPath + '/' + dataKey + '/' + data);
                    break;
                }}

    }
};exports.default =

publishAnalytics;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/publishAnalytics.js
// module id = 393
// module chunks = 0